import { useCallback } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SendCustomMailSettingMutationForCheckInBefore_00days } from "./mutation";

export const useSendCustomMailSettingForCheckInBefore_00days = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(SendCustomMailSettingMutationForCheckInBefore_00days);

	const sendTestMailAtCheckInBefore00Days = useCallback(
		async (input: CustomMailSettingTestMailInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "チェックイン当日のテストメールを送信しました",
				});
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return { sendTestMailAtCheckInBefore00Days };
};
